import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle, Notification } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { IconSendMail } from '../../../icons'
import { TENANT } from '../../../tenant'
import { productAccessorIsSaeOffer } from '../../model/productAccessor/productAccessorIsSaeOffer'
import { useProductPageContext } from '../productPageContext'

import { ProductDeliveryInfoTableSae } from './ProductDeliveryInfoTable'
import { ProductDeliveryInfoTableMarketplace } from './ProductDeliveryInfoTable/ProductDeliveryInfoTableMarketplace'

const strong = (text: ReactNode[]): JSX.Element => {
  return <strong className="font-medium">{text}</strong>
}

export const ProductDeliveryInfoDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  const { tenant } = useGlobalConfigContext()
  const {
    currentOffer,
    shipping: { marketplaceDeliveryCosts },
  } = useProductPageContext()

  if (!currentOffer) {
    return null
  }

  const isMarketplace = !productAccessorIsSaeOffer(currentOffer)

  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      slotProps={{ dialog: { className: 'w-[46rem]' } }}
    >
      <DialogTitle
        closeText={<FormattedMessage id="general.link.label.close" />}
        onClose={onClose}
      >
        <FormattedMessage id="buyBox.modal.delivery.headline" />
      </DialogTitle>
      {/* Content depends on MP product or not */}
      <DialogContent className="flex flex-col">
        {isMarketplace && marketplaceDeliveryCosts !== null ? (
          <ProductDeliveryInfoTableMarketplace
            deliveryCosts={marketplaceDeliveryCosts}
          />
        ) : (
          <>
            <ProductDeliveryInfoTableSae />
            {tenant === TENANT.COM ? (
              <Notification
                className="mt-5"
                icon={<IconSendMail />}
                severity="success"
              >
                <div className="flex flex-col font-medium text-dark-success">
                  <div className="mb-2 flex flex-row">
                    <span>
                      <FormattedMessage id="buyBox.delivery.freeDelivery.description" />
                    </span>
                  </div>
                  <p>
                    <FormattedMessage
                      id="buyBox.delivery.freeDelivery.ourTip"
                      values={{
                        strong,
                      }}
                    />
                  </p>
                </div>
              </Notification>
            ) : null}
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}
